import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useCallback, useEffect, useState } from 'react';
import Pagination from '../components/main/Pagination'
import PhoneNumberModal from './modals/PhoneNumberModal';
import UserStatesCards from './users/UserStatesCards';
import useUsersApi from '../api/useUsersApi';
import CommonLoader from '../components/loaders/CommonLoader';
import { debounce } from '../helper/debounce';
import { Avatar } from '@mui/material';
import dayjs from 'dayjs';
import UserSubscriptionStatistic from './users/UserSubscriptionStatistic';
import UserDonutChart from './users/UserDonutChart';

const UsersListLayer = ({ filter, start_date, end_date }) => {
    const [openPhone, setOpenPhone] = useState(false);
    const { getUsers, loading, getUserStates } = useUsersApi();
    const [data, setData] = useState([]);
    const [subscriptionEndDate, setSubscriptionEndDate] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [total_pages, setTotalPages] = useState(1);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedSubscription, setSelectedSubscription] = useState('');
    const [states, setStates] = useState(null);
    const [searchFilter, setSearchFilter] = useState('phone_number');

    const fetchStates = async () => {
        try {
            const params = { filter };
            if (filter === 'custom' && start_date && end_date) {
                params.start_date = start_date;
                params.end_date = end_date;
            }
            const res = await getUserStates(params);
            setStates(res?.data?.payload?.calculated_info);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    }

    const fetchUsers = async (page = 1, search = '', selectedStatus = '', selectedSubscription = '', searchFilter = 'all') => {
        const isLoginFailed = selectedSubscription === 'login_failed';
        const res = await getUsers(page, search, selectedStatus, selectedSubscription, searchFilter, isLoginFailed);
        setData(res.data.payload.all_users);
        setTotalPages(res.data.payload.total_pages);
    };
    const handleSubscriptionChange = (e) => {
        const value = e.target.value;
        setSelectedSubscription(value);
        setPage(1);
        fetchUsers(1, searchTerm, selectedStatus, value, searchFilter);
    };
    const handleStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        setPage(1);
        fetchUsers(1, searchTerm, value, selectedSubscription, searchFilter);
    };

    const debouncedfetchUsers = useCallback(
        debounce((value) => {
            setPage(1);
            fetchUsers(1, value, selectedStatus, selectedSubscription, searchFilter);
        }, 500),
        [selectedStatus, selectedSubscription, searchFilter]
    );

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedfetchUsers(value);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        fetchUsers(page, searchTerm, selectedStatus, selectedSubscription, searchFilter);
    }, [page, filter]);

    useEffect(() => {
        fetchStates();
    }, [filter, start_date, end_date]);

    const handleSearchFilterChange = (e) => {
        setSearchFilter(e.target.value);
        fetchUsers(1, searchTerm, selectedStatus, selectedSubscription, e.target.value);
    };
    return (
        <>
            {(states === null && loading) ?
                <div>
                    <CommonLoader />
                </div>
                :
                <>
                    <div className=''>
                        {states && <UserStatesCards states={states} />}
                    </div>
                    <div className="row mt-24">
                        <div className="col-xxl-8 col-md-6 mb-4">
                            {states && <UserSubscriptionStatistic states={states} />}
                        </div>
                        <div className="col-xxl-4 col-md-6 mb-4">
                            {states && <UserDonutChart second_chart_data={states?.second_chart_data} />}
                        </div>
                    </div>
                </>
            }
            {states !== null &&
                < div className="card h-100 p-0 radius-12 mt-24">
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">

                            <div className='d-flex justify-content-center align-items-center gap-2'>
                                <form className="navbar-search">
                                    <input
                                        type="text"
                                        className="bg-base h-40-px"
                                        name="search"
                                        placeholder="Search"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon icon="ion:search-outline" className="icon" />
                                </form>
                                <select
                                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                    value={searchFilter}
                                    onChange={handleSearchFilterChange}
                                >
                                    <option value="all">All</option>
                                    <option value="phone_number" defaultChecked>Mobile Number</option>
                                    <option value="email">Email</option>
                                    <option value="location">Location</option>
                                </select>
                            </div>

                            <div className='d-flex justify-content-center align-items-center gap-2'>
                                {/* <input
                                    type='date'
                                    name='subscription_end_date'
                                    className="border w-auto ps-12 py-6 radius-12 h-40-px"
                                /> */}
                                <select
                                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                >
                                    <option value="" disabled>
                                        Select Status
                                    </option>
                                    <option value="">All</option>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                                <select
                                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                    value={selectedSubscription}
                                    onChange={handleSubscriptionChange}
                                >
                                    <option value="">All</option>
                                    <option value="subscription_will_expire">Subscription Will Expire</option>
                                    <option value="subscriber">Subscriber</option>
                                    <option value="non_subscriber">Non Subscriber</option>
                                    <option value="subscription_expired">Subscription Expired</option>
                                    <option value="login_failed">Login Failed</option>
                                </select>
                            </div>

                        </div>
                    </div>
                    <div className="card-body p-24">
                        {loading ? (
                            <CommonLoader />
                        ) : (
                            <>
                                <div className="table-responsive scroll-sm">
                                    <table className="table bordered-table sm-table mb-0">
                                        <thead>
                                            <tr>
                                                <th className="text-start">Name</th>
                                                <th className="text-start">Admin</th>
                                                <th className="text-center">Duty Status</th>
                                                <th className="text-center">Subscription Days</th>
                                                <th className="text-center">Aadhaar Card Document Status</th>
                                                <th className="text-center">Phone Number.</th>
                                                <th className="text-center">Created At</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.length > 0 ? (
                                                data.map((user) => (
                                                    <tr key={user._id}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <Avatar
                                                                    src={user?.profile_photo}
                                                                    alt=""
                                                                    className="w-40-px h-40-px rounded-circle me-12"
                                                                />
                                                                <span className="text-md text-secondary-light">{user.user_name || "-"}</span>
                                                            </div>
                                                        </td>
                                                        <td className="text-center flex flex-col">
                                                            <div>{user.parent_user_id?.user_name || "-"}</div>
                                                            <div>{user.parent_user_id?.phone_number || "-"}</div>
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className={`badge ${user.duty_status == 0 ? "bg-secondary" : "bg-success"
                                                                    }`}
                                                            >
                                                                {user.duty_status == 0 ? "Offline" : "Online"}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">{user.subscription_days || "0"}</td>
                                                        <td className="text-center">
                                                            <span
                                                                className={`badge ${user.aadhaar_document_status == 0
                                                                    ? "bg-warning"
                                                                    : user.aadhaar_document_status == 1
                                                                        ? "bg-info"
                                                                        : user.aadhaar_document_status == 2
                                                                            ? "bg-success"
                                                                            : user.aadhaar_document_status == 3
                                                                                ? "bg-danger"
                                                                                : "bg-secondary"
                                                                    }`}
                                                            >
                                                                {user.aadhaar_document_status == 0
                                                                    ? "Pending"
                                                                    : user.aadhaar_document_status == 1
                                                                        ? "In Review"
                                                                        : user.aadhaar_document_status == 2
                                                                            ? "Verified"
                                                                            : user.aadhaar_document_status == 3
                                                                                ? "Unverified"
                                                                                : "-"}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">{user.phone_number || "-"}</td>
                                                        <td className="text-center">
                                                            {dayjs(user.createdAt).format('DD MMM YYYY hh:mm A')}
                                                        </td>
                                                        <td className="text-center d-flex justify-content-center">
                                                            <button
                                                                onClick={() => window.open(`/users-list/${user._id}`, '_blank')}
                                                                className="bg-info-focus text-info-600 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            >
                                                                <Icon icon="majesticons:eye-line" className="text-xl" />
                                                            </button>

                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center py-4">No Users Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                    <span>Page {page} of {total_pages}</span>
                                    <Pagination
                                        total_pages={total_pages}
                                        current_page={page}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div >}
            <PhoneNumberModal open={openPhone} setOpen={setOpenPhone}
                user_name="John Doe"
                phoneNumber="+96 5252455"
            />
        </>
    );
};

export default UsersListLayer;